import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import axios from "axios";
import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";

import Check from "@material-ui/icons/Check";

class ContactSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      success: false,
      failed: false
    };
  }

  sendMessage = ({ name, email, message }) => {
    axios
      .post("https://api.resilientvitality.com/feedback", {
        name,
        email,
        message,
        subject: "Web Site Contact Form Ticket"
      })
      .then(() => {
        this.setState({ success: true });
      })
      .catch(() => {
        this.setState({ failed: true });
      });
  };

  render() {
    const { classes } = this.props;
    const { name, email, message, success, failed } = this.state;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem cs={12} sm={12} md={8}>
            <h2 className={classes.title}>Contact Us</h2>
            <h4 className={classes.description}>
              We are still working on delivering an awesome experience. If you
              have feedback or wish to help, let us know by sending a message
              below. We'll be sure to get back to you.
            </h4>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Your Name"
                    id="name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: event =>
                        this.setState({ name: event.target.value }),
                      value: name
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Your Email"
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: event =>
                        this.setState({ email: event.target.value }),
                      value: email
                    }}
                  />
                </GridItem>
                <CustomInput
                  labelText="Your Message"
                  id="message"
                  formControlProps={{
                    fullWidth: true,
                    className: classes.textArea
                  }}
                  inputProps={{
                    multiline: true,
                    rows: 5,
                    onChange: event =>
                      this.setState({ message: event.target.value }),
                    value: message
                  }}
                />
                <GridContainer justify="center">
                  <GridItem
                    xs={12}
                    sm={12}
                    md={4}
                    className={classes.textCenter}
                  >
                    <Button
                      color="primary"
                      onClick={() => this.sendMessage(this.state)}
                    >
                      Send Message
                    </Button>
                  </GridItem>
                </GridContainer>

                {success && (
                  <SnackbarContent
                    message={
                      <span>
                        <b>SUCCESS:</b> We've got your message and will contact
                        you if need be.
                      </span>
                    }
                    close
                    color="success"
                    icon={Check}
                  />
                )}

                {failed && (
                  <SnackbarContent
                    message={
                      <span>
                        <b>Failed!:</b> Looks likes something didn't work
                        correctly. Try again later.
                      </span>
                    }
                    close
                    color="danger"
                    icon="info_outline"
                  />
                )}
              </GridContainer>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(workStyle)(ContactSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ContactSection.jsx